module.exports = __webpack_public_path__ + "static/media/progressive-insulation-windows.36529db3.png";